import { StringSchema } from ".."

export const string = () => new StringSchema()
